import React from 'react'
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'
import * as XLSX from 'xlsx'
import CreateEditBrick from './CreateEditBrick'
import CreateEditValues from './CreateEditValues'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import {
    fetchBrick,
    fetchBrickError,
    createBrick,
    updateBrick,
    updateBrickValues,
    errorBrick,
    fetchBricksList,
    import_brick_excel,
    exportBrickValues,
    importError,
    errorImport
} from './actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'
import BootstrapErrorModal from '../../../SharedComponents/UserMessaging/BootstrapErrorModal';

import './ProductBricks.css'


var Spinner = require('react-spinkit');

let chkReturn = 0;

class ProductBricks extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editBrickMode: false,
            editValuesMode: false,
            brick: {
                name: '',
                length: '0',
                example: '',
                sourceField: '',
                values: []
            },

            nameSrch: '',
            exactLength: true,
            value: -1,
            valueFilter: ''
        };

        this.fetchBrickErrorClear = this.fetchBrickErrorClear.bind(this);
        this.errorBrickClear = this.errorBrickClear.bind(this);
        this.errorImportClear = this.errorImportClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.brickEdit = this.brickEdit.bind(this);
        this.brickEditVerify = this.brickEditVerify.bind(this);
        this.brickCreate = this.brickCreate.bind(this);
        this.updateBrick = this.updateBrick.bind(this);
        this.cancelBrick = this.cancelBrick.bind(this);
        this.closeBrick = this.closeBrick.bind(this);

        this.maxLen = this.maxLen.bind(this);
        this.exactLen = this.exactLen.bind(this);

        this.search = this.search.bind(this);

        this.valuesFilter = this.valuesFilter.bind(this);
        this.valuesEdit = this.valuesEdit.bind(this);
        this.valuesCreate = this.valuesCreate.bind(this);
        this.valuesDelete = this.valuesDelete.bind(this);
        this.valuesCheck = this.valuesCheck.bind(this);
        this.afterOpen = this.afterOpen.bind(this);
        this.afterOpenValues = this.afterOpenValues.bind(this);
        this.updateValues = this.updateValues.bind(this);
        this.closeValues = this.closeValues.bind(this);
        this.import_and_end = this.import_and_end.bind(this);
        this.handleFileChosen = this.handleFileChosen.bind(this);
        this.importVerify = this.importVerify.bind(this);
        this.exportValues = this.exportValues.bind(this);
    }

    afterOpen() {
        this.brickCheck()

        if (!this.state.editBrick) {
            $('input#max').prop('checked', true)
            $('input#exact').prop('checked', false)

            this.setState({ exactLength: false })
        }
        else {
            $('input#max').prop('checked', false)
            $('input#exact').prop('checked', true)

            this.setState({ exactLength: true })

            this.props.brick.brick.values.forEach((val) => {
                if (val.code.length != this.props.brick.brick.length) {
                    $('input#max').prop('checked', true)
                    $('input#exact').prop('checked', false)

                    this.setState({ exactLength: false })
                }
            })
        }

    }
    brickCheck() {
        if ($('#brick_name').val().length === 0 || $('#brick_length').val().length === 0)
            $('button.modbrick').attr("disabled", "disabled")
        else
            $('button.modbrick').removeAttr("disabled")
    }

    fetchBrickErrorClear() {
        this.props.dispatch(fetchBrickError);
    }

    errorBrickClear(e) {
        this.props.dispatch(errorBrick);

        if (this.props.brick.error === "409") {
            let id = e.target.attributes.brick.value;

            fetchBrick.bind(this)(id);
        }
    }

    errorImportClear() {
        this.props.dispatch(errorImport);
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    brickEdit(e) {
        if (chkReturn || this.props.brick.updating) return;
        chkReturn = 1;

        let id = e.target.attributes.brick.value;

        this.setState({
            brick: {
                name: '',
                length: '0',
                example: '',
                sourceField: '',
                values: []
            }
        });

        fetchBrick.bind(this)(id);

        chkReturn = setInterval(this.brickEditVerify, 100);
    }
    brickEditVerify() {
        if (this.props.brick.updated || this.props.brick.error) {
            if (this.props.brick.updated) {
                this.setState({
                    value: -1,
                    editBrick: true,
                    editBrickMode: true
                });
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }
    brickCreate() {
        if (this.props.bricks.fetching) return

        let emptybrk = {
            name: '',
            length: '0',
            example: '',
            sourceField: '',
            values: []
        };

        this.setState({
            brick: emptybrk,
            exactLength: true,
            value: -1,
            editBrick: false,
            editBrickMode: true
        });

        updateBrickValues.bind(this)(emptybrk);
    }
    updateBrick(e) {
        $('button.modbrick').attr('disabled','disabled')

        let create = e.target.attributes.create.value;
        let brick = {
            name: $('#brick_name').val().trim(),
            length: $('#brick_length').val(),
            example: $('#brick_example').val(),
            sourceField: $('#brick_source').val() != 'Select' ? $('#brick_source').val() : "",
            values: []
        };

        this.props.brick.brick.values.forEach(function (value) {
            brick.values.push({
                code: value.code,
                name: value.name,
                language: value.language
            })
        })

        if (create === 'true') {
            createBrick.bind(this)(brick);
        }
        else {
            brick.productBrickId = parseInt($('#brick_id').text());
            updateBrick.bind(this)(brick.productBrickId, brick);
        }

        chkReturn = setInterval(this.closeBrick, 100);
    }
    cancelBrick() {
        this.props.dispatch(errorBrick);

        this.setState({
            editBrickMode: false
        });

        this.props.dispatch(fetchBricksList);
    }
    closeBrick() {
        if (this.props.brick.updated || this.props.brick.error) {
            $('button.modbrick').removeAttr('disabled')

            if (this.props.brick.updated) {
                this.cancelBrick();
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    maxLen() {
        this.setState({ exactLength: false })
        $('input#exact').prop('checked', false)
     }
    exactLen() {
        this.setState({ exactLength: true })
        $('input#max').prop('checked', false)
     }

    valuesFilter(e) {
        let filter = e.target.value.toLowerCase();

        this.setState({
            valueFilter: filter
        });
    }
    valuesEdit(e) {
        let value = parseInt(e.target.attributes.index.value);

        this.setState({
            value: value,
            editValues: true,
            editValuesMode: true
        });
    }
    valuesCreate() {
        let brick = this.state.brick

        brick.length = $('#brick_length').val()

        this.setState({
            value: -1,
            editValues: false,
            editValuesMode: true,

            brick: brick
        });
    }
    valuesDelete(e) {
        let brick = Object.assign({}, this.props.brick.brick);
        let value = parseInt(e.target.attributes.index.value);

        brick.values.splice(value, 1);
        updateBrickValues.bind(this)(brick);
    }
    afterOpenValues() {
        this.valuesCheck()
        $('input#values').val('')
    }
    updateValues() {
        let name = $('input.name').val().trim();
        let code = $('input.code').val().toLowerCase().trim();
        let brick = Object.assign({}, this.props.brick.brick);

        if (this.state.value === -1) {
            brick.values.push({
                name: name,
                code: code,
                language: "en"
            })
        }
        else {
            brick.values[this.state.value].name = name;
            brick.values[this.state.value].code = code;
        }

        this.setState({ brick: brick });

        updateBrickValues.bind(this)(brick);

        this.setState({
            valueFilter: '',
            editValuesMode: false
        });
    }
    closeValues() {
        this.setState({
            valueFilter: '',
            editValuesMode: false
        });
    }

    valuesCheck() {
        let name_len = $('input.name').val().length
        let code_len = $('input.code').val().length
        let brick_len = parseInt($('#brick_length').val())

        if ( name_len === 0 || code_len === 0 ||
            (code_len !== brick_len && this.state.exactLength) ||
            (code_len > brick_len && !this.state.exactLength))
            $('#save').attr("disabled", "disabled")
        else 
            $('#save').removeAttr("disabled")    
    }

    search(e) {
        this.setState({ nameSrch: e.target.value.toLowerCase() }) 
    }

    handleFileChosen(event) {

        var files = event.target.files;

        var mimeType = event.target.files[0]['type'];
        if (mimeType !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            alert("The File uploaded must be an excel spreadsheet wtih the file extension .xlsx");
            document.getElementById("fileChooseButton").value = null;
            return;
        }

        // if (files.size > 0) {

        // }
        var i, f, j, k;
        //Loop through files
        for (i = 0, f = files[i]; i !== files.length; ++i) {
            var name = f.name;
            const reader = new FileReader();
            reader.onload = (evt) => {
                /* Parse data */
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });
                /* Get first worksheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                /* Convert array of arrays */
                // const data = XLSX.utils.sheet_to_csv(ws, { header: 1 }); 
                const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                /* Update state */
                // UNCOMMENT OUT LATER: console.log("DATA>>>" + data);

                var coreArray = [];
                var header1 = data[0][0];
                var header2 = data[0][1];
                var header3 = data[0][2];

                if (header1.toUpperCase() !== "BRICKID" || header1 === undefined) {
                    importError.bind(this)("Missing BrickID column")
                    return;
                }
                if (header2.toUpperCase() !== "CODE" || header2 === undefined) {
                    importError.bind(this)("Missing Code column")
                    return;
                }
                if (header3.toUpperCase() !== "NAME" || header3 === undefined) {
                    importError.bind(this)("Missing Name column")
                    return;
                }



                for (k = 1; k < data.length; k++) {
                    var jsonArray = {};
                    let importModel = {
                        "BrickID": data[k][0],
                        "Code": data[k][1],
                        "Name": data[k][2]
                    };
                    let values = {};
                    for (j = 0; j < data[0].length; j++) {
                        var header = data[0][j];
                        var value = data[k][j];

                        if (value === undefined) {
                            value = "";
                        }
                        else if (value === "undefined") {
                            value = "";
                        }

                        values[header] = value;
                    }
                    //importModel["Values"] = values;
                    coreArray.push(values);
                }
                // document.getElementById("progress_bar_upload").style.display = "inline";
                document.getElementById("startImportBrick").style.display = "inline";
                console.log(JSON.stringify(coreArray));
                var brickID = this.props.brick.brick.productBrickId
                var exact = document.getElementById("max");

                var exactField = true;
                if (exact.checked === true) {
                    exactField = false;
                }

                import_brick_excel.bind(this)(brickID, exactField, coreArray);

            };
            reader.readAsBinaryString(f);
        }

        chkReturn = setInterval(this.importVerify, 100);
    }

    importVerify() {
        if (this.props.brick.percent_complete == 100 || this.props.brick.errorImport) {
            if (this.props.brick.percent_complete == 100) {
                fetchBrick.bind(this)(this.props.brick.brick.productBrickId)
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    import_and_end(event) {

        //this.handleFileChosen(event);
        document.getElementById("fileChooseButtonBrick").click();
    }

    exportValues(e) {
        exportBrickValues.bind(this)(e.currentTarget.attributes.brick.value)
    }

    render() {
        return (
            <div className="product-bricks col-xs-12">
                <CommError error={this.props.brick.error} onClose={this.errorBrickClear} />
                <CommError error={this.props.bricks.error} onClose={this.fetchBrickErrorClear} />

                <ConfirmModal open={this.props.bricks.noData} heading={"Product Bricks"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                <BootstrapErrorModal
                    show={this.props.brick.errorImport != null}
                    title={'Import Values'}
                    body={this.props.brick.errorImport}
                    onClose={this.errorImportClear}
                />

                <div className="headWrapper">
                    <div className="productBricks">
                        <h1>Product Bricks</h1>
                    </div>
                </div>

                <div id="srch">
                    <span>Search by Name:</span>
                    {
                        this.props.bricks.fetching ?
                            <input id="name" disabled />
                        :
                            <input id="name" autoComplete="off" spellCheck="false" onChange={this.search} />
                    }
                    <button className="btn btn-primary pull-right" onClick={this.brickCreate}>+ Create Brick</button>
                </div>

                <div className="tableWrapper"> 
                    {
                        this.props.bricks.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }
                    <table className="lists table table-striped">
                        <thead>
                            <tr className="head">
                                <th>Brick Name</th>
                                <th>Last Edited</th>
                                <th>Source</th>
                                <th>Example</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.bricksList ?
                                    this.props.bricksList.filter((brick) => {
                                        if (this.state.nameSrch.length) {
                                            if (brick.name.toLowerCase().startsWith(this.state.nameSrch)) {
                                                brick.prefix = brick.name.substring(0, this.state.nameSrch.length)
                                                brick.suffix = brick.name.substring(this.state.nameSrch.length)

                                                return true
                                            }
                                            else
                                                return false
                                        }
                                        else return true
                                    }).map((brick, index) => {
                                        return <tr className="body" key={index}>
                                            <td className="name" brick={brick.productBrickId} onClick={this.brickEdit}>
                                                {this.state.nameSrch.length ? <p><span className="srch">{brick.prefix}</span><span>{brick.suffix}</span></p> : brick.name }
                                            </td>
                                            <td>{brick.lastUpdatedAtDisplay}</td>
                                            <td>{brick.sourceField}</td>
                                            <td>{brick.example}</td>
                                            <td>
                                                <OverlayTrigger placement="top" overlay={<Tooltip id={index}>Edit</Tooltip>}>
                                                    <i className="fa fa-edit" brick={brick.productBrickId} onClick={this.brickEdit}></i>
                                                </OverlayTrigger>
                                            </td>
                                        </tr>
                                    })
                                : null
                            }
                        </tbody>
                    </table>
                </div>

                <CreateEditBrick
                    errBrick={this.props.brick}
                    errBrickClear={this.errorBrickClear}
                    curBrick={this.props.brick.brick}
                    tmpBrick={this.state.brick}

                    fieldNames={this.props.bricks.fieldNames}

                    create={this.state.editBrick}
                    isOpen={this.state.editBrickMode}

                    onAfterOpen={this.afterOpen}
                    onRequestClose={this.updateBrick}
                    onRequestCancel={this.cancelBrick}

                    maxBrickLength={this.maxLen}
                    exactBrickLength={this.exactLen}

                    filter={this.state.valueFilter}
                    onValuesFilter={this.valuesFilter}
                    onValuesEdit={this.valuesEdit}
                    onValuesCreate={this.valuesCreate}
                    onValuesDelete={this.valuesDelete}
                    valuesCheck={this.brickCheck}
                    importValues={this.import_and_end}
                    startImportValues={this.handleFileChosen}
                    exportValues={this.exportValues}
                />
                <CreateEditValues
                    curValue={this.state.value}

                    curBrick={this.state.editValues ? this.props.brick.brick : this.state.brick}

                    exactLength={this.state.exactLength}

                    create={this.state.editValues}
                    isOpen={this.state.editValuesMode}

                    brickCreate={this.state.editBrick}

                    onAfterOpen={this.afterOpenValues}
                    onRequestClose={this.updateValues}
                    onRequestCancel={this.closeValues}

                    valuesCheck={this.valuesCheck}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    brick: state.brick,
    bricks: state.bricks
});

export default connect(mapStateToProps)(ProductBricks)